import React, { FC } from 'react';

import useGetMe from '../../hooks/useCurrentUser';

import SplashModal from './components/modal';
import { dismissSplash } from './actions';
import { SplashDTO } from './types';

interface SplashProps {
  splash: SplashDTO;
  onClose(): void;
}

const Splash: FC<SplashProps> = ({ splash, onClose }) => {
  const user = useGetMe();

  const handleDismiss = async () => {
    if (user?.id) await dismissSplash(splash.id, user.id);
    onClose();
  };

  return (
    <SplashModal
      open
      imageUrl={splash.imageUrl}
      onClose={onClose}
      onDismiss={handleDismiss}
    />
  );
};

export default Splash;
